module.exports = __webpack_public_path__ + "static/media/Registration_Team.530137b8.gif";